import { CHECKIN_THANKYOU, KEY_THANKYOU } from "../../routes/Paths";
import { STEP_MASTER_ENUM } from "../../constants/constant";
import {
  getDeviceDetails,
  getPropertyInfo,
} from "../../store/Checkin/Scan/propertySlice";
import {
  getParametersFromLocalStorage,
  homePageHandler,
  updateTimeToDefaultCheckout,
  updateTimeToDefaultCheckout_MIWA,
} from "../../helpers/commonHelper";
import { initReactI18next, useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import CreateKey from "../../components/Createkey/Createkey";
import DownloadKeyModal from "../../components/Layout/Card/DownloadKeyModal";
import Footer from "../../components/Layout/Footer";
import HomePageCard from "../../components/Layout/Card/HomePageCard";
import KeyCard from "../../components/Layout/Card/KeyCard";
import KeyFooter from "../../components/Layout/KeyFooter";
import SuccessPopup from "../../components/LoaderAndNotification/SuccessPopup";
import { encodeKey, getReservationDetails } from "../../network/apiService";
import { getModuleConfiguration } from "../../store/Checkin/moduleConfigurationSlice";
import {
  getPassportScanData,
  getRoomNo,
  setRoomNo,
} from "../../store/Checkin/Scan/scanPassportSlice";
import { getStepMaster } from "../../helpers/commonHelper";
import { postAuditLog, postStageDetails } from "../../store/stageSlice";
import { keyencodingTimerConstantValue } from "../../constants/timers";
import useUserActivity from "../../hooks/useUserActivity";

import PriorityBadge from "../../components/Layout/PriorityBadge";
import { useLocation } from "react-router-dom";
const CreateKeyPassportScan = () => {
  const location = useLocation();
  const reservationData = location.state?.reservationData;
  const { screen } = useParams();
  const { t } = useTranslation();
  const timeLimit = keyencodingTimerConstantValue;
  const [firstKeyDone, setFirstKeyDone] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showKeyModal, setShowKeyModal] = useState(false);
  const [createAdditionalKey, setCreateAdditionalKey] = useState(false);
  const [showDownloadKeyModal, setDownloadKeyModal] = useState(false);
  const [timerValue, setTimerValue] = useState(timeLimit);
  const [restartTimer, setRestartTimer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successPopup, setSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState();
  const [erroModalData, setErrorModalData] = useState({
    toggleError: false,
    errorMessage: "",
  });
  const userData = useSelector(getPassportScanData);
  const roomNo = useSelector(getRoomNo);
  const [freezeTimer, setFreezeTimer] = useState(false);

  const stepMaster = useSelector((state) => getModuleConfiguration(state));
  const checkinKeyPage = getStepMaster(stepMaster, STEP_MASTER_ENUM.KEY_PAGE);
  useEffect(() => {
    //debugger;
    console.log("screen", screen);
    console.log("checkinKeyPage", checkinKeyPage);
    if (
      screen !== "key" &&
      (checkinKeyPage === null || checkinKeyPage === undefined)
    ) {
      navigate(`${CHECKIN_THANKYOU}`, { replace: true });
    } else {
      const refreshRoomNo = async () => {
        const newObj = {
          pmsConfirmationNo: userData?.pmsConfirmationNo,
          reservationNameID: userData?.reservationNameID,
        };
        var _reservation = await getReservationDetails(newObj, token);
        dispatch(setRoomNo(_reservation?.data?.data?.roomNo ?? roomNo));
      };
      refreshRoomNo();
    }
  }, []);

  // useEffect(() => {
  //   if (keyPage === null || keyPage === undefined) {
  //     navigate(`${CHECKIN_THANKYOU}`, { replace: true });
  //   }
  // }, [keyPage, navigate]);

  useEffect(() => {
    if (!userData) {
      //console.warn("userData is undefined");
      addLog(
        "userData is undefined",
        "false",
        "Keypage selector returned no guest data"
      );
    } else {
      //console.log("userData from Redux:", userData);
      addLog(JSON.stringify(userData), "true", "Keypage userData loaded");
    }
  }, [userData]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = getParametersFromLocalStorage("token");

  const propertyData = useSelector(getPropertyInfo);
  const deviceDetails = getParametersFromLocalStorage("DeviceInfo");
  const isFaceMatchEnabled = getParametersFromLocalStorage("faceMatch");

  const resetTimerAndClosePopUp = () => {
    if (!timerValue) {
      setTimerValue(timeLimit);
    }
    setRestartTimer(true);
    setShowModal(false);
  };

  const timerCounter = (value) => {
    setTimerValue(value);
  };

  const openModal = () => {
    setShowModal(true);
  };

  const keyModal = () => {
    setShowKeyModal(false);
  };

  const closeKeyModal = () => {
    setShowKeyModal(false);
    doneDownloadKey();
    return;
  };

  const openDownloadKey = () => {
    setDownloadKeyModal(true);
  };

  const closeDownloadKey = () => {
    setDownloadKeyModal(false);
  };

  const doneDownloadKey = () => {
    setTimeout(() => {
      setSuccessPopup(false);
      if (screen === "key") {
        navigate(`${KEY_THANKYOU}`, { replace: true });
      } else {
        navigate(`${CHECKIN_THANKYOU}`, { replace: true });
      }
    }, 2000);
  };

  const skipKey = () => {
    setSuccessMessage(t("Skipping key encoding.."));
    setSuccessPopup(true);
    if (!firstKeyDone) {
      // if first key is done then let stage status as success
      const data = {
        PMSConfirmationNo: userData?.pmsConfirmationNo,
        IsSuccess: true,
        StepCode: "SKI09",
        SubStep: "Key Encoding",
        AppType: "kiosk",
        SuccessMessage: "Skipped",
        FailureReason: "",
        PropertyCode: propertyData.data.propertyCode,
      };

      dispatch(postStageDetails({ data, token }));
    }

    doneDownloadKey();
  };

  const stopTimer = () => {
    setRestartTimer(false);
  };

  const closeErrorModal = () => {
    setErrorModalData((state) => ({
      ...state,
      toggleError: false,
      errorMessage: "",
    }));
  };
  const [keyCreationCount, setKeyCreationCount] = useState(0);
  const totalGuestCount = parseInt(
    localStorage.getItem("totalGuestCount") || 0
  );

  const createKeyHandler = async () => {
    try {
      const kiosk = getParametersFromLocalStorage("Kiosk");

      const encoderID = deviceDetails
        ? deviceDetails?.find((ele) => ele?.settingsName === "EncoderID")
        : deviceDetails;

      const encoderUrl = deviceDetails
        ? deviceDetails?.find((ele) => ele?.settingsName === "EncoderURL")
        : deviceDetails;

      const encoderTerminalID = deviceDetails
        ? deviceDetails?.find(
            (ele) => ele?.settingsName === "EncoderTerminalID"
          )
        : deviceDetails;

      const encoderPort = deviceDetails
        ? deviceDetails?.find((ele) => ele?.settingsName === "EncoderPort")
        : deviceDetails;

      const encoderUsername = deviceDetails
        ? deviceDetails?.find((ele) => ele?.settingsName === "EncoderUsername")
        : deviceDetails;

      const encoderPassword = deviceDetails
        ? deviceDetails?.find((ele) => ele?.settingsName === "EncoderPassword")
        : deviceDetails;
      const encoderProperty = deviceDetails
        ? deviceDetails?.find((ele) => ele?.settingsName === "EncoderProperty")
        : deviceDetails;

      const settings = getParametersFromLocalStorage("settings");
      const checkOutTime =
        settings?.find((setting) => setting.parameterName === "CheckOutTime")
          ?.parameterValue ?? "12:00 AM";

      const maxKeyCount =
        settings?.find((setting) => setting.parameterName === "MaxKeyCount")
          ?.parameterValue ?? totalGuestCount;

      const dtt = checkOutTime
        ?.replace(" ", "")
        ?.replace("AM", "")
        ?.replace("PM", "")
        ?.split(":");

      // const departureDate = userData?.departureDate;

      // // Extract the date part (YYYY-MM-DD) from the departureDate
      // const [datePart, _] = departureDate.split(' ');

      // // Combine the date part with the desired check-out time
      // const fullDateTimeString = `${datePart} ${dtt[0]}:${dtt[1]}`; // Use hours and minutes from checkOutTime

      // // Convert the combined string into a Date object
      // const checkOutDtTime = new Date(`${fullDateTimeString} UTC`).toISOString();  // Ensure it's treated as UTC

      // console.log(checkOutDtTime);  // Example output: "2024-07-09T11:00:00.000Z"

      let checkOutDtTime;
      if (propertyData.data.keyVendor == "MIWA") {
        checkOutDtTime = updateTimeToDefaultCheckout_MIWA(
          userData?.departureDate,
          dtt[0]
        ); //commneted as checkout time is changing to 2PM when set as 11 AM
      } else {
        checkOutDtTime = updateTimeToDefaultCheckout(
          userData?.departureDate,
          dtt[0]
        ); //commneted as checkout time is changing to 2PM when set as 11 AM
      }
      //const checkOutDtTime = updateTimeToDefaultCheckout(userData?.departureDate, dtt[0]) //commneted as checkout time is changing to 2PM when set as 11 AM

      if (!userData || !userData.pmsConfirmationNo) {
        addLog(
          JSON.stringify(userData),
          "false",
          "userData is null or missing pmsConfirmationNo during key encoding"
        );
      }

      const sendData = {
        confirmationNo: userData?.pmsConfirmationNo,
        reservationNameID: userData?.reservationNameID,
        roomNumber: userData?.roomNo,
        guestName: userData?.lastName,
        arrivalDate: userData?.arrivalDate,
        departureDate: userData?.departureDate,
        workStation: kiosk,
        encoderID: encoderID?.settingsValue ?? "",
        terminalID: encoderTerminalID?.settingsValue,
        //keyEncoderProperty: "Main",
        keyEncoderProperty: encoderProperty?.settingsValue,
        reservationNo: userData?.pmsConfirmationNo,
        isNewKey: createAdditionalKey === true ? false : true,
        checkinDateTime: userData?.arrivalDate,
        checkoutDateTime: checkOutDtTime,
        uRL: encoderUrl?.settingsValue ?? "",
        encoderPort:
          encoderPort?.dataType == "int"
            ? parseInt(encoderPort?.settingsValue ?? "1")
            : encoderPort?.settingsValue ?? "",
        encoderUsername: encoderUsername?.settingsValue,
        encoderPassword: encoderPassword?.settingsValue,
      };

      const keyVendor = propertyData?.data?.keyVendor ?? "UnknownVendor";

      const logData = {
        requestData: sendData,
        keyVendor: keyVendor,
        token: token ?? "no-token",
      };
      let stringifiedLogData = "";

      try {
        stringifiedLogData = JSON.stringify(logData);
      } catch (err) {
        console.error("Failed to stringify logData:", err);
        stringifiedLogData = "Stringify failed: " + err.message;
      }

      const logMessage = `Key Encoding Request for PMSConfirmationNo: ${
        userData?.pmsConfirmationNo ?? "Unknown"
      }`;
      addLog("", stringifiedLogData, logMessage);

      // addLog(
      //   "",
      //   JSON.stringify({
      //     requestData: sendData, // Request payload
      //     keyVendor: propertyData.data.keyVendor, // Additional request data
      //     token: token, // Token used for authentication
      //   }),
      //   `Key Encoding Request for PMSConfirmationNo: ${userData?.pmsConfirmationNo}`
      // );

      //if (createAdditionalKey) setShowKeyModal(false);
      try {
        setFreezeTimer(true);
        <Footer freezeTimer={freezeTimer} />;

        setLoading(true);
        const response = await encodeKey(
          sendData,
          token,
          propertyData.data.keyVendor
        );

        addLog(
          JSON.stringify(response),
          JSON.stringify(sendData),
          `Key Encoding Request for PMSConfirmationNo: ${userData?.pmsConfirmationNo}`
        );
        setFreezeTimer(false);
        <Footer freezeTimer={freezeTimer} />;
        if (response?.data?.result === true) {
          setCreateAdditionalKey(true);
          // Increment the count
          addLog(
            "Key encoding response " + response?.data?.result,
            JSON.stringify(sendData),
            "Key encoding success"
          );
          localStorage.setItem("RoomPin", response?.data?.data?.pin ?? "");

          setLoading(false);
          setKeyCreationCount((prevCount) => {
            const newCount = prevCount + 1;
            if (newCount <= maxKeyCount - 1) {
              setShowKeyModal(true);
            } else {
              setSuccessMessage(t("Key Issued Successfully!!"));
              setSuccessPopup(true);
              setFirstKeyDone(true);
              doneDownloadKey();
            }
            return newCount;
          });

        } else {
          addLog(
            JSON.stringify(response),
            JSON.stringify(sendData),
            "Key encoding response " + response?.data?.result
          );
          setLoading(false);
          setErrorModalData((state) => ({
            ...state,
            toggleError: true,
            errorMessage: t(
              "Unable to encode the key. Please contact front desk for assistance."
            ),
          }));
        }
      } catch (ex) {
        addLog(
          JSON.stringify(ex),
          JSON.stringify(sendData),
          `Key Encoding Exception for PMSConfirmationNo: ${userData?.pmsConfirmationNo}`
        );
      }
    } catch (error) {
      // addLog(
      //   JSON.stringify(error),
      //   "false",
      //   "Key encoding exception " + userData?.pmsConfirmationNo
      // );

      addLog(
        JSON.stringify(error),
        "false",
        `Key encoding exception ${
          userData?.pmsConfirmationNo || "No userData available"
        }`
      );

      setLoading(false);
      setErrorModalData((state) => ({
        ...state,
        toggleError: true,
        errorMessage: t(
          "Unable to encode the key. Please contact front desk for assistance."
        ),
      }));
      return;
    }
  };
  const handlebackPage = () => {
    try {
      homePageHandler(dispatch, navigate);
    } catch (error) {
      console.error("Error capturing image:", error);
    }
  };

  const addLog = (response, request, message) => {
    const confirmationNo = localStorage.getItem("confirmationNo");
    const data = {
      ActionName: "Key Encoding",
      Message: message ?? "",
      ControllerName: "kiosk",
      Request: request ?? "",
      PMSConfirmationNo: confirmationNo,
      AppType: "kiosk",
      Response: response ?? "",
      PropertyCode: propertyData?.data?.propertyCode,
    };
    dispatch(postAuditLog({ data, token }));
  };

  //KC-447 Timer need to restart when user interaction is involved
  useUserActivity(() => {
    setTimerValue(timeLimit);
  });

  return (
    <div>
      {/* uncomment to show badge */}
      <div
        style={{
          position: "absolute",
          top: "40px",
          right: "20px",
          zIndex: 10,
        }}
      >
        {/* <PriorityBadge /> */}
        <PriorityBadge reservationData={reservationData} />
      </div>
      <CreateKey
        openModal={openModal}
        loading={loading}
        userData={userData}
        erroModalData={erroModalData}
        closeErrorModal={closeErrorModal}
        openDownloadKey={openDownloadKey}
        createKeyHandler={createKeyHandler}
        navigateTo={doneDownloadKey}
        handlebackPage={handlebackPage}
        skipKey={skipKey}
        roomNo={roomNo}
      />

      {screen === "key" ? (
        <>
          <KeyFooter
            page={"key"}
            showModal={showModal}
            openModal={openModal}
            timerCounter={timerCounter}
            timerValue={timerValue}
            restartTimer={restartTimer}
            stopTimer={stopTimer}
            timeLimit={timeLimit}
            isFaceMatchEnabled={isFaceMatchEnabled}
            freezeTimer={freezeTimer}
          />
        </>
      ) : (
        <>
          <Footer
            page={"key"}
            showModal={showModal}
            openModal={openModal}
            timerCounter={timerCounter}
            timerValue={timerValue}
            restartTimer={restartTimer}
            stopTimer={stopTimer}
            timeLimit={timeLimit}
            freezeTimer={freezeTimer}
          />
        </>
      )}

      {showModal && (
        <HomePageCard
          showModal={showModal}
          resetTimerAndClosePopUp={resetTimerAndClosePopUp}
        />
      )}
      {showKeyModal && (
        <KeyCard
          closeKeyModal={closeKeyModal}
          keyModal={createKeyHandler}
          createAdditionalKey={createAdditionalKey}
        />
      )}
      {showDownloadKeyModal && (
        <DownloadKeyModal
          closeDownloadKey={closeDownloadKey}
          doneDownloadKey={doneDownloadKey}
        />
      )}
      {successMessage && (
        <SuccessPopup loading={successPopup} successMessage={successMessage} />
      )}
    </div>
  );
};

export default CreateKeyPassportScan;
